import * as homeUrls from 'mk2/apps/home/urls';
import * as wikiUrls from 'mk2/apps/wiki/urls';
import { Route } from 'mk2/containers/Application/Application';
import RedirectPage from 'mk2/pages/RedirectPage';

export const routes: Route[] = [{
    app: 'wiki',
    exact: true,
    path: wikiUrls.wikiArticleCreate,
    getPage: () => {
        return import('mk2/apps/wiki/containers/ArticleCreate/ArticleCreatePage' /* webpackChunkName: "wiki.ArticleCreate" */);
    },
    modules: [ 'mk2/apps/wiki/containers/ArticleCreate/ArticleCreatePage' ],
}, {
    app: 'wiki',
    exact: true,
    path: wikiUrls.wiki,
    page: new RedirectPage({to: homeUrls.homepage, permanent: true}),
}, {
    app: 'wiki',
    exact: true,
    path: wikiUrls.wikiArticleEdit,
    getPage: () => {
        return import('mk2/apps/wiki/containers/ArticleEdit/ArticleEditPage' /* webpackChunkName: "wiki.ArticleEdit" */);
    },
    modules: [ 'mk2/apps/wiki/containers/ArticleEdit/ArticleEditPage' ],
}, {
    app: 'wiki',
    exact: true,
    path: wikiUrls.wikiArticle,
    getPage: () => {
        return import('mk2/apps/wiki/containers/Article/ArticlePage' /* webpackChunkName: "wiki.Article" */);
    },
    modules: [ 'mk2/apps/wiki/containers/Article/ArticlePage' ],
}, {
    app: 'wiki',
    exact: true,
    path: wikiUrls.wikiAddExperience,
    getPage: () => {
        return import('mk2/apps/wiki/containers/ArticleAddExperience/ArticleAddExperiencePage' /* webpackChunkName: "wiki.ArticleAddExperience" */);
    },
    modules: [
        'mk2/apps/wiki/containers/ArticleAddExperience/ArticleAddExperiencePage',
        'mk2/apps/wiki/containers/Article/ArticlePage',
    ],
}];
